import React from 'react';
import { FormattedMessage } from 'react-intl';
import LoginCallback from '@okta/okta-react/dist/LoginCallback';
import LoginError from './LoginError';


const ImplicitLoginCallback = () => (<LoginCallback errorComponent={LoginError} />);

export default ImplicitLoginCallback;